<template>
  <div>
    <div v-if="!innerIsReview">
      <validation-provider v-slot="{errors}" :rules="rules" :name="title || 'This'" v-show="innerShouldShow" :vid="'validate-'+fieldAssignmentId">
        <v-autocomplete
          v-model="innerValue"
          v-bind="vProps"
          :items="states"
          item-text="name"
          item-value="iso2"
          hide-details="auto"
        >
          <template #label>
              <span v-if="title" v-html="title"></span>
          </template>
        </v-autocomplete>
      </validation-provider>
    </div>
    <div v-else>
      <type-review
              v-if="extraProps"
              :label="title"
              :directions="directions"
              :should-show="innerShouldShow"
              :show-edit-button="extraProps.editButton"
              :page-number="extraProps.originalPageNumber"
              @goToPage="goToPage($event)"
      >
        <div v-if="innerValue">
          <span v-html="innerValue"></span>
        </div>
        <div v-else>N/A</div>
      </type-review>
    </div>
  </div>
</template>

<script>
import { getStates } from 'country-state-picker'
import formMixin from '../formMixin'
import TypeReview from "./TypeReview";

export default {
  name: 'TypeState',
  mixins: [formMixin],
  components:{
    TypeReview
  },
  data() {
    return {
      country: 'us',
    }
  },
  mounted() {
    this.$nextTick(() => {
      if( this.field_path ) {
        const value = this.getSiblingValue(this.field_path.replace('.state', '.country'));
        if( value )
          this.country = value;
      }
    });

    this.fieldLoaded(); // signal to the form we are loaded

    // see if country changes
    this.$root.$on('fieldChanged', data => {
      let {field, value} = data;
      if( field.field_path?.includes('.country') ) {
        if( !value )
          value = this.getSiblingValue(field.field_path);

        if( value )
          this.country = value;
      }
    });
  },
  computed: {
    defaults() {
      return {
        persistentHint: true,
      }
    },
    title() {
      return this.country === 'CA' ? this.innerLabel.replace('State', 'Province') : this.innerLabel
    },
    rules() {
      return (this.enableValidation) ? {
        ...this.validation_settings,
        ...{required:!!this.validation_settings.required && !!this.innerShouldShow}
      } : {}
    },
    states() {
      return getStates(this.country.toLowerCase())
    },
  },
}
</script>
